import { useCallback, useMemo } from "react"
import { DecorativeLine } from "@/components/base/DecorativeLine"
import { getAssetsUrlWithHttp, resolveAssetImage } from "@/utils/common"
import styled from "@emotion/styled"
import { Link } from "react-router-dom"
import { IndexData } from "@/features_signal/indexData"

const FollowUsStyled = styled.section`
    font-family: Gilroy;
    margin: 29rem 12rem 0;
    padding-bottom: 29rem;
`

const Title = styled.h3`
    padding: 0;
    margin: 0;
    margin-top: 7rem;
    font-weight: 700;
    font-size: 16rem;
    height: 24rem;
    line-height: 24rem;
    text-align: center;
`

const SocialContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24rem;
    flex-wrap: nowrap;
    height: 44rem;
    margin-top: 8rem;
`

const Social = styled.img`
    width: 36rem;
    height: 36rem;
    border-radius: 6rem;
    object-fit: contain;
`

const ALink = styled(Link)`
    width: 36rem;
    height: 36rem;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`

const followItems = [
    {
        icon: resolveAssetImage("pages/HomePage/img_fb.webp"),
        link: "https://www.facebook.com/filbet6/",
    },
    {
        icon: resolveAssetImage("pages/HomePage/img_ig.webp"),
        link: "https://www.instagram.com/filbet01/",
    },
    {
        icon: resolveAssetImage("pages/HomePage/img_x.webp"),
        link: "https://x.com/Filbet_6",
    },
    {
        icon: resolveAssetImage("pages/HomePage/img_tg.webp"),
        link: "https://t.me/+UUcXz17rZkw2MzY1",
    },
    {
        icon: resolveAssetImage("pages/HomePage/img_viber.webp"),
        link: "https://www.viber.com/filbet",
    },
]

let clickCount = 0
let lastClickTime = 0

export function FollowUs() {
    const handleClick = useCallback(() => {
        const now = Date.now()
        if (now - lastClickTime < 500) {
            clickCount++
            if (clickCount >= 30) {
                const eruda = document.getElementById("eruda")
                if (eruda) {
                    eruda.style.display = "block"
                }
                clickCount = 0 // 重置计数
            }
        } else {
            clickCount = 0 // 点击间隔过长，重置计数
        }
        lastClickTime = now
    }, [])

    return (
        <FollowUsStyled>
            <DecorativeLine
                width={351}
                height={1}
                color={"#D5D5D8"}
            />
            <Title onTouchStart={handleClick}>Follow Us</Title>
            <SocialContainer>
                {IndexData.dataMedia.value.length > 0
                    ? IndexData.dataMedia.value.map((item, idx) => {
                          return (
                              <ALink
                                  to={item.link_h5 || "/"}
                                  key={`media_item_${idx}`}
                                  target="_blank"
                              >
                                  <Social
                                      src={getAssetsUrlWithHttp(item.url)}
                                      alt=""
                                  />
                              </ALink>
                          )
                      })
                    : followItems.map(({ link, icon }, idx) => {
                          return (
                              <ALink
                                  to={link}
                                  key={`media_item_${idx}`}
                                  target="_blank"
                              >
                                  <Social
                                      src={icon}
                                      alt=""
                                  />
                              </ALink>
                          )
                      })}
            </SocialContainer>
        </FollowUsStyled>
    )
}
